<template>
  <DropdownMenuTrigger 
    :as-child="asChild"
    v-bind="$attrs"
  >
    <slot />
  </DropdownMenuTrigger>
</template>

<script setup>
import { DropdownMenuTrigger } from 'radix-vue'

const props = defineProps({
  asChild: {
    type: Boolean,
    default: false
  }
})
</script>